import { render } from "./UpcomingTestsList.vue?vue&type=template&id=2869564a"
import script from "./UpcomingTestsList.vue?vue&type=script&lang=js"
export * from "./UpcomingTestsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__